import Axios from '@/utils/axios';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export interface Outlet {
  id: number | string;
  name: string;
  address?: string;
  city?: string;
  province?: string;
  district?: string;
  subDistrict?: string;
  zipCode?: string;
  latitude?: number;
  longitude?: number;
  contactPerson?: string;
  contactPhone?: string;
  providerID?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface OutletListResponse {
  data: Outlet[];
  pagination?: {
    total: number;
    page: number;
    size: number;
    lastPage: number;
  };
}

// GET /mgmt/v1/providers/:providerID/outlets — outlets are scoped to a
// provider (client), so the caller must pick a client first.
export const getOutletsByProvider = async (
  providerID: number | string,
  params: { page?: number; size?: number; search?: string } = {}
): Promise<OutletListResponse> => {
  try {
    const response = await Axios.get(
      `/mgmt/v1/providers/${providerID}/outlets`,
      {
        params: {
          page: params.page ?? 1,
          size: params.size ?? 9999,
          ...(params.search ? { search: params.search } : {}),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
